import * as React from 'react';
import isLocalStorageAvailable from '../../../services/mini/isLocalStorageAvailable';

type CollapsiblePanelProps = {
    id: string,
    title: string,
    shortPanelClassName?: string,
    direction: string,
    children: React.ReactChild,
    panelClassName?: string,
    disabled?: boolean,
    collapsed?: boolean,
    actionPanel?: React.ReactChild,
    onPanelCollapsed?: () => void;
    onPanelExpanded?: () => void;
};


type CollapsiblePanelState = {
    collapsed: boolean,
};

class CollapsiblePanel extends React.Component<CollapsiblePanelProps, CollapsiblePanelState> {
    constructor(props, context) {
        super(props, context);

        const id = this.props.id;

        this.state = {
            collapsed: isLocalStorageAvailable() ? (localStorage.getItem(id) === 'true' ? true : false) : false
        };
    }

    componentDidMount(): void {
        const { onPanelCollapsed, onPanelExpanded } = this.props;
        const { collapsed } = this.state;

        if (collapsed && onPanelCollapsed) onPanelCollapsed();
        if (!collapsed && onPanelExpanded) onPanelExpanded();
    }

    componentDidUpdate(prevProps: Readonly<CollapsiblePanelProps>, prevState: Readonly<CollapsiblePanelState>, snapshot?: any): void {
        const { collapsed } = this.props;

        if (this.state.collapsed !== collapsed && collapsed !== undefined) {
            this.setState({ collapsed: collapsed });
        }
    }

    togglePanel = () => {
        const { collapsed } = this.state;
        const { onPanelCollapsed, id, onPanelExpanded } = this.props;

        if (isLocalStorageAvailable()) {
            localStorage.setItem(id, (!collapsed).toString());
        }

        this.setState({ collapsed: !collapsed });

        if (!collapsed && onPanelCollapsed) {
            onPanelCollapsed();
        }

        if (collapsed && onPanelExpanded) {
            onPanelExpanded();
        }
    }

    render() {
        const { collapsed } = this.state;
        const { disabled, actionPanel, direction, title, shortPanelClassName = 'collapsible-panel_dark-bg', panelClassName } = this.props;

        const shortPanel = <div
            className={`collapsible-panel_short-variant ${collapsed && 'collapsed'} ${direction} ${shortPanelClassName}`}>
            <div
                className="collapsible-panel_short-variant_title"
                onClick={this.togglePanel}>
                {title}
            </div>
            {actionPanel && <div className={`collapsible-panel_actions-holder `}>
                {actionPanel}
            </div>}
        </div>;

        return (
            <div className={`collapsible-panel ${collapsed && 'collapsed'} ${direction} ${disabled && 'disabled'} ${panelClassName}`}>
                <div
                    className="collapsible-panel_toggle-btn"
                    onClick={this.togglePanel}>
                    <i className="icon icon-alan-chevron-fat arrow-el" />
                </div>
                <div className="collapsible-panel_content">
                    {direction === 'right' && shortPanel}
                    {this.props.children}
                    {direction === 'left' && shortPanel}
                </div>
            </div>
        );
    }
}


export default CollapsiblePanel;
